<template>
  <layout-auth>
    <v-toolbar flat color="grey lighten-3" height="50px">
      <v-container>
        <a @click="$router.push('/cuentas-de-abono')" class="sub-nav">{{
          $t("accounts.management")
        }}</a>
        <a
          style="font-weight: bold; color: #222222 !important"
          class="sub-nav"
        >
          {{ $t("accounts.addAccount") }}</a
        >
      </v-container>
    </v-toolbar>
    <v-container class="py-10">
      <v-row class="pb-5">
        <v-col>
          <h1 class="text-h4 font-weight-light py-5">
            {{ $t("accounts.accountNumber") }}
          </h1>
          <p>{{ $t("accounts.altaCuentaAbono") }}</p>
        </v-col>
      </v-row>
      <v-form v-model="formulario" ref="form" autocomplete="off">
        <v-row>
          <v-col>
            <h2 class="text-h5 font-weight-light">
              {{ $t("accounts.accountData") }}
            </h2>
            <h3 class="text-subtitle-1 font-weight-medium">
              {{ $t("accounts.accountMessage") }}
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <label>{{ $t("accounts.accountNumber") }}</label>
            <v-text-field-simplemask
              v-model="form.iban"
              @keyup="deleteBic"
              @change="deleteBic"
              v-bind:properties="{
                rules: [rules.required],
                maxlength: '29',
                prefix: '',
                suffix: '',
                readonly: false,
                disabled: false,
                outlined: true,
                dense: true,
                placeholder: 'ES00 0000 0000 0000 0000 0000',
                clearable: true,
                color: entityConfig.primaryColor,
              }"
              v-bind:options="{
                inputMask: '#### #### #### #### #### #### #### #### ##',
                outputMask: '####################################',
                applyAfter: false,
                alphanumeric: true,
                lowerCase: false,
              }"
            />
          </v-col>
          <v-col cols="12" sm="12" md="2" lg="2">
            <label>{{ $t("accounts.bic") }}</label>
            <v-text-field
              :rules="[rules.bic]"
              :disabled="spainIban"
              v-model="form.bic"
              dense
              outlined
              :color="entityConfig.primaryColor"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="8" lg="8">
            <label>{{ $t("accounts.description") }}</label>
            <v-text-field
              :rules="[rules.required]"
              v-model="form.description"
              dense
              outlined
              :color="entityConfig.primaryColor"
              max="30"
              maxlength="30"
              counter
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="pb-5">
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-btn
              @click="post_created_account"
              depressed
              :color="entityConfig.primaryColor"
              :style="`color: ${entityConfig.secondaryColor}`"
              class="float-end v-btn-width-default"
              :disabled="!formIsValid"
            >
              {{ $t("supplierData.save") }}
            </v-btn>
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-form>
    </v-container>
  </layout-auth>
</template>

<script>
import Api from "../../Services/index";

import LayoutAuth from "../../components/layouts/layout-auth.vue";
import IBAN from "iban";

export default {
  components: {
    "layout-auth": LayoutAuth,
  },
  data: (addAccountComponent) => ({
    dialog: false,
    dialog7: false,
    dialog8: false,

    disableBic: true,
    entityConfig: {},
    formulario: false,
    respuesta: "",
    form: {
      description: "",
      iban: "",
      bic: "",
    },
    rules: {
      isIban: (v) => IBAN.isValid(v) || "Iban no valido",
      maxIban: (v) => v.length <= 44 || "34 caracteres Maximo",
      required: (value) => !!value || "Este campo es requerido..",
      bic: (v) => {
        if (!addAccountComponent.spainIban) {
          return !!v || "Este campo es requerido..";
        }

        return true;
      },
    },
  }),

  mounted() {
    
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");

    this.userdata = JSON.parse(sessionStorage.getItem("userData"));
    this.userId = this.userdata.supplierId.trim();


    let newAccount = JSON.parse(sessionStorage.getItem("accountConfirm"));
    if (newAccount) {
      this.form = newAccount;
    }
    sessionStorage.removeItem("accountConfirmEdit");
    
  },

  computed: {
    formIsValid() {
      return this.formulario;
    },
    spainIban() {
      return this.form?.iban?.startsWith("ES");
    },
  },

  methods: {
    deleteBic() {
      if (this.spainIban) {
        this.form.bic = "";
      }
      this.$refs.form.validate();
    },

    async post_created_account() {
      try {
        this.spinner = true;
        const formData = new FormData();
        formData.append("iban", this.form.iban);
        formData.append("bic", this.form.bic);
        formData.append("description", this.form.description);
        Api.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("authtoken");
        const obj = Object.assign({}, this.form);
        await Api.post(`/proveedores/${this.userId}/cuentas-abono`, obj).then(
          (response) => {
            this.respuesta = response.data;

            // ----------------------------------------------------------------------
            if (this.respuesta.response.codEcvEgc === "2") {
              sessionStorage.setItem(
                "accountConfirm",
                JSON.stringify(this.form)
              );
              sessionStorage.setItem(
                "response",
                JSON.stringify(this.respuesta)
              );
               let message = "Su cuenta se validó automáticamente";
                this.$toast.success(message);
              this.$router.push("/cuentas-de-abono/confirmar");
            }
            // ----------------------------------------------------------------------------
            if (
              this.respuesta.response.codEcvEgc === "6" &&
              this.respuesta.response.indSitVal === "S"
            ) {
              sessionStorage.setItem(
                "accountConfirm",
                JSON.stringify(this.form)
              );
              sessionStorage.setItem(
                "response",
                JSON.stringify(this.respuesta)
              );
              this.$router.push("/cuentas-de-abono/confirmar");
            }

            if (
              // ESTE ES SOLO BTN ADJUNTA Y DESCARGAR
              this.respuesta.response.codEcvEgc === "6" &&
              this.respuesta.response.indSitVal === "N" 
            ) {
          
              sessionStorage.setItem(
                "accountConfirm",
                JSON.stringify(this.form)
              );
              sessionStorage.setItem(
                "response",
                JSON.stringify(this.respuesta)
              );
              this.$router.push("/cuentas-de-abono/confirmar");
            }

            if (
              // ESTE ES SOLO BTN ADJUNTA
              this.respuesta.response.codEcvEgc === "6" &&
              this.respuesta.response.indSitVal === "N" 
            ) {
              sessionStorage.setItem(
                "accountConfirm",
                JSON.stringify(this.form)
              );
              sessionStorage.setItem(
                "response",
                JSON.stringify(this.respuesta)
              );
              this.$router.push("/cuentas-de-abono/confirmar");
            }
          }
        );
       
      } catch (error) {
        this.$showError(this, error.response.data);
      } finally {
        this.spinner = false;
      }
    },

    confirmCreate() {
      sessionStorage.setItem("accountConfirm", JSON.stringify(this.form));
      this.$router.push("/cuentas-de-abono/confirmar");
    },
  },
};
</script>
